import React from "react"

function NotFound() {
  return (
    <div>
      <p className=" text-xl">page not found</p>
    </div>
  )
}

export default NotFound
